import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import * as m from 'motion/react-m';
import type { PropsWithChildren } from 'react';
export function Panel(t0) {
  const $ = _c(8);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1,
      transition: {
        delay: 0.25,
        duration: 0.5
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      transition: {
        delay: 0,
        duration: 0.5
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = cx("absolute top-full mt-2 w-full rounded-2xl bg-white p-4 shadow-elevation3", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <m.div key="panel" initial={t1} animate={t2} exit={t3} className={t4}>{children}</m.div>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}